import { fetchHistorySuccessAction } from '.'
import { Config } from '../utils/config'

const fetchHistory = async (dispatch, limit, offset, throwAsyncError) => {
  try {
    const response = await fetch(
      `${Config.BASE_URL}/history?limit=${limit}&offset=${offset}`,
      {
        method: 'GET',
        credentials: 'include'
      }
    )

    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()
    dispatch(fetchHistorySuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

export { fetchHistory }
